import { Collapsible as ChakraCollapsible } from "@chakra-ui/react";
import type { ComponentProps } from "react";
import type { CollapsibleSharedProps } from "./Collapsible.props";

export default function Collapsible(props: CollapsibleProps): JSX.Element {
  // Extract props explicitly so we can control prop names in one place
  const {
    children,
    in: isOpen,
    open,
    unmountOnCollapse,
    unmountOnExit,
    animateOpacity,
    ...rest
  } = props;

  // Map v1/v2 props to v3 props for backward compatibility
  const openValue = open ?? isOpen ?? false;
  const unmountValue = unmountOnExit ?? unmountOnCollapse;

  const contentAnimationProps = animateOpacity
    ? {
        _open: { animationName: "fade-in", animationDuration: "200ms" },
        _closed: { animationName: "fade-out", animationDuration: "120ms" },
      }
    : undefined;

  return (
    <ChakraCollapsible.Root
      open={openValue}
      unmountOnExit={unmountValue}
      aria-hidden={openValue ? undefined : "true"}
      {...rest}
    >
      <ChakraCollapsible.Content {...contentAnimationProps}>
        {children}
      </ChakraCollapsible.Content>
    </ChakraCollapsible.Root>
  );
}

type ChakraCollapsibleRootProps = ComponentProps<typeof ChakraCollapsible.Root>;

export type CollapsibleProps = CollapsibleSharedProps &
  Omit<
    ChakraCollapsibleRootProps,
    "children" | "open" | "unmountOnExit" | "lazyMount"
  > & {
    // Add any web specific props here.
  };
